// @flow

import duplicateEstimateCaveat from '../../../Services/duplicateEstimateCaveat';
import type { DuplicateEstimateCaveatParams } from '../../../types';

export default (params: DuplicateEstimateCaveatParams) => async (dispatch: Function) => dispatch(duplicateEstimateCaveat(params))